import styled from 'styled-components';
import { orange, white } from '../../style/colors';

export const Container = styled.div`
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 12px 20px;
  margin: 8px 20px;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

export const Label = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: #6b7280;
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;

  i {
    font-size: 16px;
    color: ${orange};
  }
`;

export const ChipList = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  flex: 1;
`;

export const Chip = styled.button`
  background: ${white};
  border: 1px solid #e5e7eb;
  border-radius: 20px;
  padding: 6px 12px 6px 14px;
  font-size: 13px;
  color: #374151;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);

  &:hover {
    background: #fff5f0;
    border-color: ${orange};
    color: ${orange};
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(255, 165, 0, 0.15);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const ChipText = styled.span`
  font-weight: 500;
`;

export const RemoveIcon = styled.i`
  font-size: 14px;
  color: #9ca3af;
  transition: color 0.2s;

  &:hover {
    color: #ef4444;
  }
`;

export const ClearButton = styled.button`
  background: none;
  border: none;
  color: #6b7280;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  padding: 6px 12px;
  border-radius: 6px;
  transition: all 0.2s;
  white-space: nowrap;

  &:hover {
    background: #f3f4f6;
    color: #374151;
  }

  &:active {
    transform: scale(0.95);
  }
`;

export const VehicleChip = styled.button`
  background: linear-gradient(135deg, #fff8f0 0%, #fff5eb 100%);
  border: 1.5px solid #ffd7a8;
  border-radius: 10px;
  padding: 8px 12px;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 10px;
  box-shadow: 0 1px 3px rgba(255, 165, 0, 0.1);

  &:hover {
    background: linear-gradient(135deg, #fff5eb 0%, #ffedd5 100%);
    border-color: ${orange};
    transform: translateY(-1px);
    box-shadow: 0 3px 6px rgba(255, 165, 0, 0.2);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const VehicleChipIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background: ${orange};
  border-radius: 6px;
  color: ${white};
  flex-shrink: 0;

  i {
    font-size: 14px;
  }
`;

export const VehicleChipInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1px;
  text-align: left;
`;

export const VehicleChipTitle = styled.span`
  font-weight: 600;
  font-size: 12px;
  color: #78350f;
`;

export const VehicleChipDetails = styled.span`
  font-size: 10px;
  color: #a16207;
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const VehicleChipCount = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${orange};
  color: ${white};
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 600;
  white-space: nowrap;
`;

